module.exports = __webpack_public_path__ + "static/media/errorBannerIcon.9fdd45c5.svg";